import { render } from "./TwitterOverview.vue?vue&type=template&id=fa6840c0"
import script from "./TwitterOverview.vue?vue&type=script&lang=js"
export * from "./TwitterOverview.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__